import { useContext } from "react"
import { ActionButton, BaseTable, Button, Loading, TableHeader } from "components"
import { DataBillContext, DataContext } from "../../contexts"
import { IoSendSharp } from "react-icons/io5"
import moment from "moment"
import { Link, useParams } from "react-router-dom"
import { APPROVAL, convertNumber, useApi } from "utils"
import { default_option } from "pages/Purchase/utils"
import toast from "react-hot-toast"

export const PaymentBillService = () => {
  const api = useApi()
  const data = useContext(DataContext) 
  const { id } = useParams()
  const { payment_list, bill_status, refetch } = useContext(DataBillContext)

  const isEnabled: boolean = data.approval_status === 4 && bill_status === "Open"

  return (
    <>
      <BaseTable>
        <TableHeader>
          <tr>
            <th rowSpan={2}>NO</th>
            <th rowSpan={2}>PAYMENT BILL ID</th>
            <th rowSpan={2}>DATE</th>
            <th rowSpan={2}>STATUS</th>
            <th rowSpan={2}>REF BILL ID#</th>
            <th rowSpan={2}>MEMO</th>
            <th colSpan={2}>PAYMENT</th>
            <th rowSpan={2}>TOTAL PAYMENT BILL</th>
            <th rowSpan={2}>ACTION</th>
          </tr>

          <tr>
            <th>DEPO</th>
            <th>PAYMENT</th>
          </tr>
        </TableHeader>

        <tbody>
          {!payment_list.length ? (
            <tr>
              <td colSpan={10}>
                <Loading errorText="No data available" />
              </td>
            </tr>
          ) : payment_list.map((item, key) => {
            const deposit_amount = item.deposit_amount
            const payment_amount = item.payment_amount

            return (
              <tr key={key}>
                <td className="text-center">{key + 1}</td>
                <td className="text-center">{item.trx_code}</td>
                <td className="text-center">{moment(item.transaction_date).format("DD/MM/YYYY")}</td>
                <td className="text-center">{default_option.find(i => item.approve_status.toString() === i.value)?.label}</td>
                <td className="text-center">{item.ref_bill_id}</td>
                <td>{item.memo}</td>
                <td className="text-right">{convertNumber(deposit_amount).intoCurrency}</td>
                <td className="text-right">{convertNumber(payment_amount).intoCurrency}</td>
                <td className="text-right">{convertNumber(deposit_amount + payment_amount).intoCurrency}</td>
                <td>
                  <div className="flex gap-2">
                    <Link to={`/purchase/transaction/payment-bill-service/edit/${item?.payment_bill_id}`}>
                      <button className="mt-2">
                        <IoSendSharp /> 
                      </button>
                    </Link>
                    {item?.approve_status === APPROVAL.PENDING && <ActionButton.Delete className="join-item" onClick={() => {
                      toast.promise(api.delete(`/paymentbill/deletepayment?payment_bill_id=${item?.payment_bill_id}`), {
                        loading: "Loading...",
                        success: (res) => res.data.message,
                        error: (err) => err.response.data.message
                      })
                      .then(() => { if (typeof refetch === "function") refetch() })
                      .catch(() => {})
                    }} />}
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </BaseTable>

      <section className="flex justify-end mt-3">
        <Link to={isEnabled ? `/purchase/transaction/payment-bill-service/${id}` : "#"}>
          <Button color="primary" disabled={!isEnabled}>
            CREATE PAYMENT BILL
          </Button>
        </Link>
      </section> 
    </>
  )
}